export const getAttemptsForModeration = (payload?: any) => ({
  type: "@saga/GET_ATTEMPTS_FOR_MODERATION",
  payload,
});
